import * as preact from "preact";

import readlangClient from "readlangClient";

// Types for props
type Props = {
  appRouter: any;
};

// Types for state
type State = {
  query: string;
  users?: User[];
};

// Bind generics to ExpandableProps and ExpandableState
export default class AdminUsersView extends preact.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      query: "",
      users: undefined,
    };
  }

  async fetchUsers() {
    const data = (
      await readlangClient.request("GET", "/api/user/list", {
        query: this.state.query,
      })
    ).data;

    console.log("data: ", data);
    this.setState({ users: data.users });
  }

  render() {
    return (
      <div>
        <h1>
          <a href="/admin">Admin</a> - Users
        </h1>
        <div>
          <h2>Search by email, user ID, object ID, or Stripe Customer ID</h2>
          <p style={{ display: "flex" }}>
            <input
              type="text"
              placeholder="Enter user email or ID to search for"
              value={this.state.query}
              onInput={(event) => {
                this.setState({ query: event.currentTarget.value });
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  this.fetchUsers();
                }
              }}
            ></input>
            <button onClick={() => this.fetchUsers()}>Search</button>
          </p>
          {this.state.users !== undefined ? (
            <div>
              <p>
                Got {this.state.users.length} user
                {this.state.users.length !== 1 ? "s" : ""}
              </p>
              {this.state.users.map((user) => {
                return (
                  <div>
                    <h2>{user.email}</h2>
                    <pre>{JSON.stringify(user, null, 2)}</pre>
                    <button
                      onClick={async () => {
                        await readlangClient.request(
                          "POST",
                          `/api/user/${user._id}/cancelSubscriptionImmediately`,
                          {}
                        );
                        this.fetchUsers();
                      }}
                    >
                      Unsubscribe (make sure to refund on Stripe too)
                    </button>
                    <button
                      onClick={async () => {
                        const rawMonths = prompt("Enter number of months");
                        const months = parseInt(rawMonths, 10);
                        if (!months) {
                          alert("Invalid number of months");
                          return;
                        }

                        await readlangClient.request(
                          "POST",
                          `/api/user/${user._id}/applyPremium`,
                          {
                            months,
                          }
                        );
                        this.fetchUsers();
                      }}
                    >
                      Apply Premium...
                    </button>
                  </div>
                );
              })}
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
